import type { ModuleMigrationDef } from "@kubdee/sdk";

// ============================================================================
// Issue #497 — Inventory period close and exception queue.
// ============================================================================

export const migration: ModuleMigrationDef = {
  key: "004_inventory_close",
  version: "1.3.0",
  sql: `
    CREATE TABLE IF NOT EXISTS \`inventory_period_closes\` (
      \`id\` text PRIMARY KEY NOT NULL,
      \`company_id\` text NOT NULL,
      \`period_month\` text NOT NULL,
      \`status\` text DEFAULT 'closed' NOT NULL,
      \`reason\` text,
      \`valuation_delta\` real DEFAULT 0 NOT NULL,
      \`gl_inventory_delta\` real DEFAULT 0 NOT NULL,
      \`gl_cogs_delta\` real DEFAULT 0 NOT NULL,
      \`variance_amount\` real DEFAULT 0 NOT NULL,
      \`exception_count\` integer DEFAULT 0 NOT NULL,
      \`closed_at\` text,
      \`closed_by\` text,
      \`reopened_at\` text,
      \`reopened_by\` text,
      \`created_at\` text NOT NULL,
      \`created_by\` text,
      \`updated_at\` text NOT NULL,
      \`updated_by\` text,
      \`deleted_at\` text,
      \`deleted_by\` text
    );
    CREATE INDEX IF NOT EXISTS \`ipc_company_period_idx\`
      ON \`inventory_period_closes\` (\`company_id\`, \`period_month\`);
    CREATE INDEX IF NOT EXISTS \`ipc_company_status_idx\`
      ON \`inventory_period_closes\` (\`company_id\`, \`status\`);

    CREATE TABLE IF NOT EXISTS \`inventory_close_exceptions\` (
      \`id\` text PRIMARY KEY NOT NULL,
      \`company_id\` text NOT NULL,
      \`period_month\` text NOT NULL,
      \`exception_key\` text NOT NULL,
      \`exception_type\` text NOT NULL,
      \`severity\` text DEFAULT 'warning' NOT NULL,
      \`status\` text DEFAULT 'open' NOT NULL,
      \`source_module\` text,
      \`source_doctype\` text,
      \`source_id\` text,
      \`stock_entry_id\` text,
      \`item_id\` text,
      \`warehouse_id\` text,
      \`posting_date\` text,
      \`message\` text NOT NULL,
      \`details\` text,
      \`retry_count\` integer DEFAULT 0 NOT NULL,
      \`last_retry_at\` text,
      \`resolved_at\` text,
      \`resolved_by\` text,
      \`resolution_note\` text,
      \`created_at\` text NOT NULL,
      \`created_by\` text,
      \`updated_at\` text NOT NULL,
      \`updated_by\` text,
      \`deleted_at\` text,
      \`deleted_by\` text
    );
    CREATE INDEX IF NOT EXISTS \`ice_company_period_status_idx\`
      ON \`inventory_close_exceptions\` (\`company_id\`, \`period_month\`, \`status\`);
    CREATE INDEX IF NOT EXISTS \`ice_company_key_idx\`
      ON \`inventory_close_exceptions\` (\`company_id\`, \`exception_key\`);
    CREATE INDEX IF NOT EXISTS \`ice_stock_entry_idx\`
      ON \`inventory_close_exceptions\` (\`company_id\`, \`stock_entry_id\`);
  `,
};
